export default {
  namespaced: true,
  state: {
    // 作成するレポートの種類
    createReportType: "", // attendance | photo | rectification
  },
  getters: {
    createReportType: state => state.createReportType,
  },
  mutations: {
    setCreateReportType(state, createReportType) {
      state.createReportType = createReportType
    }
  },
  actions: {
    updateCreateReportType({ commit }, createReportType) {
      commit('setCreateReportType', createReportType)
    },
  },
}